module.exports = __webpack_public_path__ + "img/SAVE.e462377c.svg";